import { graphql } from 'gatsby'
import React from 'react'

import Persons from '@/components/persons/persons'

const FeaturedLeaders: React.FC<Queries.FeaturedLeaderFragment> = ({
  leader,
  title,
  isDark
}) => {
  const persons = leader?.reduce<Queries.PersonDetailFragment[]>(
    (acc, curr) => {
      if (curr?.person != null) {
        acc.push(curr.person)
      }
      return acc
    },
    []
  )

  if (persons !== undefined && persons?.length > 0) {
    return <Persons persons={persons} title={title} isDark={isDark === true} />
  } else {
    return <></>
  }
}

export default FeaturedLeaders

export const query = graphql`
  fragment FeaturedLeader on DatoCmsFeaturedLeader {
    __typename
    id
    title
    navigationLabel
    isDark
    leader {
      ...Leader
    }
  }
`
